module.exports = __webpack_public_path__ + "static/media/cloud-moon-rain.5ac81347.svg";